if (!customElements.get('gift-card-recipient-form')) {
  class GiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.parentForm = this.closest('form');
      this.checkboxInput = this.querySelector('[data-gift-card-recipient-checkbox]');
      this.recipientFields = this.querySelector('[data-gift-card-recipient-fields]');
      this.emailInput = this.querySelector('[data-gift-card-recipient-email]');
      this.nameInput = this.querySelector('[data-gift-card-recipient-name]');
      this.messageInput = this.querySelector('[data-gift-card-recipient-message]');
      this.noJsInput = this.querySelector('[data-gift-card-recipient-no-js-input]');

      this.hideFields();
      this.updateEmailPlaceholder();
      this.checkboxInput.addEventListener('change', this.onChange.bind(this));
      this.parentForm.addEventListener('submit', this.onSubmit.bind(this));
    }

    hideFields () {
      this.recipientFields.classList.add('d-none');
      this.noJsInput.disabled = true;
    }

    updateEmailPlaceholder() {
      const newPlaceholder = this.emailInput.getAttribute('data-gift-card-recipient-email-placeholder');
      this.emailInput.setAttribute('placeholder', newPlaceholder);
    }

    onChange() {
      if (this.checkboxInput.checked) {
        this.recipientFields.classList.remove('d-none');
        this.parentForm.removeAttribute('novalidate');
        this.emailInput.setAttribute('required', true);
      } else {
        this.emailInput.value = '';
        this.nameInput.value = '';
        this.messageInput.value = '';
        this.recipientFields.classList.add('d-none');
        this.emailInput.removeAttribute('required');
        this.parentForm.setAttribute('novalidate', 'novalidate');
      }
    }

    onSubmit() {
      setTimeout(() => {
        this.checkboxInput.checked = false;
        this.checkboxInput.dispatchEvent(new Event('change'));
      }, 200);
    }
  }

  customElements.define('gift-card-recipient-form', GiftCardRecipientForm);
}
